module.exports = __webpack_public_path__ + "media/amp_version/google-045aee4e.svg";